const MINI_CURRENT_DAY = (new Date(Date.now())).getDate()
const MINI_CURRENT_MONTH = (new Date(Date.now())).getMonth()
const MINI_CURRENT_YEAR = (new Date(Date.now())).getFullYear()
let MINI_CURRENT_DATE = new Date(MINI_CURRENT_YEAR, MINI_CURRENT_MONTH, MINI_CURRENT_DAY)
const MAX_NEXT_CLICK = 13

let miniCalendarModule = {
  dateFrom: null,
  dateTo: null,
  currentDate: null,
  animationDuration: 250,
  clickCounter: 0,
  firstDayInFilter: null,
  secondDayInFilter: null,
  filterDatePeriod: null,
  swipeValue: 330,
  nextClicCounter: 0,
  createMiniCalendar: function (elem) {
    let table = '<div class="mini-calendar__inner-wrapper">'
    table += '<div class="mini-calendar__inner-container">'

    let d = new Date(miniCalendarModule.currentDate.getFullYear(), miniCalendarModule.currentDate.getMonth())
    for (let i = 0; i < MAX_NEXT_CLICK; i++) {
      table += `<div class="mini-calendar__inner-item"><div class="mini-calendar__header-container" >
                <div class="mini-calendar__header-prevButton" onClick="miniCalendarModule.handlePrevButtonClickWithThrottle()"></div>
                <div class="mini-calendar__header-monthName">${horizontalCalendarModule.getMonthsName(d.getMonth())}</div>
                <div class="mini-calendar__header-nextButton" onClick="miniCalendarModule.handleNextButtonClickWithThrottle()"></div>
            </div>`
      table += '<table class="mini-calendar__table">' +
        '<tbody>' +
        '<tr>' +
        '<th class="mini-calendar__day-primary">пн</th>' +
        '<th class="mini-calendar__day-primary">вт</th>' +
        '<th class="mini-calendar__day-primary">ср</th>' +
        '<th class="mini-calendar__day-primary">чт</th>' +
        '<th class="mini-calendar__day-primary">пт</th>' +
        '<th class="mini-calendar__day-weekDay mini-calendar__day-primary">сб</th>' +
        '<th class="mini-calendar__day-weekDay mini-calendar__day-primary">вс</th>' +
        '</tr><tr>'
      for (let i = 0; i < this.getDay(d); i++) {
        table += '<td></td>'
      }

      while (d.getMonth() === miniCalendarModule.currentDate.getMonth()) {
        let disabledClass = d < MINI_CURRENT_DATE ? 'disabled' : ''
        table += `<td class="mini-calendar__day-wrapper ${disabledClass}" 
            data-data="${d}"
            onclick="miniCalendarModule.handleDayClick(event)">           
            <span class="mini-calendar__day-item"><span class="mini-calendar__day-number">${d.getDate()}</span></span></td>`
        if (this.getDay(d) % 7 === 6) {
          table += '</tr><tr>'
        }
        d.setDate(d.getDate() + 1)
      }
      if (this.getDay(d) !== 0) {
        for (let i = this.getDay(d); i < 7; i++) {
          table += '<td></td>'
        }
      }
      table += '</tr></tbody>'
      table += '</table></div>'

      miniCalendarModule.currentDate.setMonth(d.getMonth() + 1)
      miniCalendarModule.currentDate = new Date(d.getFullYear(), d.getMonth())
    }
    table += '</div>'
    table += '</div>'
    elem.innerHTML = table
  },
  getDay: function (date) {
    let day = date.getDay()
    if (day === 0) day = 7
    return day - 1
  },
  handleDayClick: function (event) {
    let node = event.currentTarget
    horizontalCalendarModule.unActivatedAllDay()
    horizontalCalendarModule.clearRangeStyleActiveDay()
    horizontalCalendarModule.clickCounter = 0
    if ($(node).hasClass('disabled')) {
      return
    }
    if ($(node).hasClass('mini-calendar__day-active')) {
      submitHomeGridDateFilter(null, null)
      horizontalCalendarModule.initAllDaysFromApi()
      miniCalendarModule.unActivatedAllDay()
      miniCalendarModule.clearRangeStyleActiveDay()
      miniCalendarModule.clickCounter = 0
      return
    }
    $(node).addClass('mini-calendar__day-active')
    miniCalendarModule.clickCounter++
    if (miniCalendarModule.clickCounter === 1) {
      miniCalendarModule.firstDayInFilter = new Date(node?.dataset?.data)
      miniCalendarModule.filterDatePeriod = null
    }

    if (miniCalendarModule.clickCounter === 2) {
      miniCalendarModule.secondDayInFilter = new Date(node?.dataset?.data)
      miniCalendarModule.makeRangeStyleActiveDay(miniCalendarModule.getActiveDayIndex())
      let data = [miniCalendarModule.firstDayInFilter, miniCalendarModule.secondDayInFilter].sort((a, b) => {
        return new Date(a) - new Date(b)
      })
      miniCalendarModule.clickCounter = 0
      miniCalendarModule.filterDatePeriod = horizontalCalendarModule.dateDiffInDays(miniCalendarModule.secondDayInFilter, miniCalendarModule.firstDayInFilter)
      miniCalendarModule.firstDayInFilter = data[0]
      miniCalendarModule.secondDayInFilter = data[1]
    }

    if (miniCalendarModule.filterDatePeriod) {
      miniCalendarModule.dateFrom = `${miniCalendarModule.firstDayInFilter.getFullYear()}_${miniCalendarModule.firstDayInFilter.getMonth() + 1}_${miniCalendarModule.firstDayInFilter.getDate()}`
      miniCalendarModule.dateTo = `${miniCalendarModule.secondDayInFilter.getFullYear()}_${miniCalendarModule.secondDayInFilter.getMonth() + 1}_${miniCalendarModule.secondDayInFilter.getDate()}`
      submitHomeGridDateFilter(miniCalendarModule.dateFrom, miniCalendarModule.dateTo)
    } else {
      miniCalendarModule.dateFrom = `${miniCalendarModule.firstDayInFilter.getFullYear()}_${miniCalendarModule.firstDayInFilter.getMonth() + 1}_${miniCalendarModule.firstDayInFilter.getDate()}`
      miniCalendarModule.dateTo = miniCalendarModule.dateFrom
      submitHomeGridDateFilter(miniCalendarModule.dateFrom, miniCalendarModule.dateTo)
    }
    if (miniCalendarModule.clickCounter === 1) {
      miniCalendarModule.filterDatePeriod = null
      this.unActivatedAllDay()
      this.clearRangeStyleActiveDay()
      $(node).addClass('mini-calendar__day-active')
    }
  },
  handleNextButtonClickWithThrottle: function () {
    horizontalCalendarModule.throttle(miniCalendarModule.handleNextButtonClick, miniCalendarModule.animationDuration)()
  },
  handleNextButtonClick: function () {
    if (miniCalendarModule.nextClicCounter >= MAX_NEXT_CLICK - 1) {
      return
    }
    if (miniCalendarModule.nextClicCounter >= MAX_NEXT_CLICK - 2) {
      let buttonNext = $($('.mini-calendar__header-nextButton')).last()
      if (!$(buttonNext).hasClass('buttonNextDisabled')) {
        $(buttonNext).addClass('buttonNextDisabled')
      }
    }
    miniCalendarModule.nextClicCounter++

    let prevButton = $('.mini-calendar__header-prevButton')[0]
    if ($(prevButton).hasClass('buttonPrevDisabled')) {
      $(prevButton).removeClass('buttonPrevDisabled')
    }

    let containerInner = $('.mini-calendar__inner-container')[0]
    let containerInnerLeft = window.getComputedStyle(containerInner).left
    $(containerInner).animate({ left: parseInt(containerInnerLeft) - miniCalendarModule.swipeValue }, miniCalendarModule.animationDuration)
  },
  handlePrevButtonClickWithThrottle: function () {
    horizontalCalendarModule.throttle(miniCalendarModule.handlePrevButtonClick, miniCalendarModule.animationDuration)()
  },
  handlePrevButtonClick: function () {
    if (miniCalendarModule.nextClicCounter <= 0) {
      return
    }
    if (miniCalendarModule.nextClicCounter <= 1) {
      let buttonPrev = $('.mini-calendar__header-prevButton')[0]
      if (!$(buttonPrev).hasClass('buttonPrevDisabled')) {
        $(buttonPrev).addClass('buttonPrevDisabled')
      }
    }
    let nextButton = $($('.mini-calendar__header-nextButton')).last()
    if ($(nextButton).hasClass('buttonNextDisabled')) {
      $(nextButton).removeClass('buttonNextDisabled')
    }
    miniCalendarModule.nextClicCounter--
    let containerInner = $('.mini-calendar__inner-container')[0]
    let containerInnerLeft = window.getComputedStyle(containerInner).left
    $(containerInner).animate({ left: parseInt(containerInnerLeft) + miniCalendarModule.swipeValue }, miniCalendarModule.animationDuration)
  },
  makeRangeStyleActiveDay: function (arr) {
    let allDayItems = $('.mini-calendar__day-wrapper')
    let [startIndex, endIndex] = arr
    for (let i = startIndex; i <= endIndex; i++) {
      $(allDayItems[i]).addClass('mini-calendar__day-range')
    }
  },
  getActiveDayIndex: function () {
    let allDayItems = $('.mini-calendar__day-wrapper')
    let activeIndex = []
    for (let i = 0; i < allDayItems.length; i++) {
      if ($(allDayItems[i]).hasClass('mini-calendar__day-active')) {
        activeIndex.push(i)
      }
    }
    return activeIndex
  },
  paintDays: function (data) {
    let allDates = $('.mini-calendar__day-wrapper')
    for (let i = 0; i < allDates.length; i++) {
      let date2 = new Date($(allDates[i]).data().data)
      for (let j = 0; j < data.length; j++) {
        let date = new Date(data[j])
        if (date.getFullYear() === date2.getFullYear() && date.getMonth() === date2.getMonth() && date.getDate() === date2.getDate()) {
          $(allDates[i]).addClass('mini-calendar__day-hasEvent')
          break
        }
      }
    }
  },
  clearAllHasEventDays: function () {
    let days = $('.mini-calendar__day-hasEvent')
    for (let i = 0; i < days.length; i++) {
      $(days[i]).removeClass('mini-calendar__day-hasEvent')
    }
  },
  clearRangeStyleActiveDay: function () {
    let allDayItems = $('.mini-calendar__day-wrapper')
    for (let i = 0; i < allDayItems.length; i++) {
      if ($(allDayItems[i]).hasClass('mini-calendar__day-range')) {
        $(allDayItems[i]).removeClass('mini-calendar__day-range')
      }
      if ($(allDayItems[i]).hasClass('mini-calendar__day-firstIndex')) {
        $(allDayItems[i]).removeClass('mini-calendar__day-firstIndex')
      }
      if ($(allDayItems[i]).hasClass('mini-calendar__day-secondIndex')) {
        $(allDayItems[i]).removeClass('mini-calendar__day-secondIndex')
      }
    }
  },
  unActivatedAllDay: function () {
    let allDayItems = $('.mini-calendar__day-wrapper')
    for (let i = 0; i < allDayItems.length; i++) {
      if ($(allDayItems[i]).hasClass('mini-calendar__day-active')) {
        $(allDayItems[i]).removeClass('mini-calendar__day-active')
      }
    }
    miniCalendarModule.dateFrom = null
    miniCalendarModule.dateTo = null
  },
  initialStateInit: function (date) {
    miniCalendarModule.currentDate = date
  },
  init: function () {
    let buttonPrev = $('.mini-calendar__header-prevButton')[0]
    $(buttonPrev).addClass('buttonPrevDisabled')
    miniCalendarModule.nextClicCounter = 0
    miniCalendarModule.clickCounter = 0
  },
  addHideClickOutsideEventListener: function (container) {
    $('.main-wrapper').click(function (event) {//TODO unbind?
      const hideMiniCalendar = (element) => {
        $(element).fadeOut(miniCalendarModule.animationDuration, 'swing', () => {
          $(element).remove()
        })
      }
      if (event.target.id !== 'mini-calendar' && $(event.target).parents('#mini-calendar').length === 0) {
        hideMiniCalendar(container)
        horizontalCalendarModule.paintDaysFromUrlParams()
        horizontalCalendarModule.makeRangeStyleActiveDay(horizontalCalendarModule.getActiveDayIndex())
        horizontalCalendarModule.clickCounter = 0
        let [dateFromUrl, dateToUrl] = horizontalCalendarModule.getDateFromUrl()
        if (!!dateFromUrl && !!dateToUrl) {
          let [yearFrom, monthFrom, dateFrom] = dateFromUrl.split('_')
          let [yearTo, monthTo, dateTo] = dateToUrl.split('_')
          $($(`*[data-data="${new Date(Number(yearTo), Number(monthTo - 1), Number(dateTo))}"]`)[0]).removeClass('firstIndex')
          $($(`*[data-data="${new Date(Number(yearFrom), Number(monthFrom - 1), Number(dateFrom))}"]`)[0]).removeClass('secondIndex')
        }
        $('.main-wrapper').unbind('click')
      }
    })
  }

}
